module.exports = __webpack_public_path__ + "static/img/zzhc.300975a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zzhc.png
// module id = mI3Z
// module chunks = 1